import { cloneDeep } from "lodash";
import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../../../../app/common-components/ButtonComponent.jsx";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown.jsx";
import DiscardChanges from "../../../../app/common-components/DiscardChanges.jsx";
import Spinners from "../../../../app/common-components/Spinner";
import Input from "../../../../app/common-components/form/input.jsx";
import CommonBtn from "../../../../app/common-components/ui-components/Button/Index.jsx";
import { useCommonAlert } from "../../../../app/utilities/helpers.js";
import {
  AssetConfigurationObj,
  initialFormData,
  isInitialFormDataEmptyOrZero,
} from "../AssetConfiguration/Constants.js";
import "../styles.scss";
import { getServerList, getTypeList } from "./AssetSlice.js";


const AddAssetConfig = (props) => {
  const dispatch = useDispatch();
  const { common } = useSelector((state) => state);
  const { userName, userRole } = common.loggedUser;
  let { getCmdbId } = useSelector((state) => state.cmdbId);
  const [dubValidation, setdubValidation] = useState(true);
  //API Datas
  const { getLoading, serverList, getData, tableList, typeList } = useSelector(
    (state) => state.assetApi
  );
  //
  const [state, setState] = useState({
    formData: { ...initialFormData },
  });
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const [alert, setAlert] = useState({
    addBodyConfig: false,
  });

  const [isdisable, setDisable] = useState(true);
  const [serverCopy, setServerCopy] = useState(false);
  const [keyforType, setKeyforType] = useState(false);
 useEffect(() => {
  console.log("getData in useEffect:", getData);
  console.log("props.callFrom:", props.callFrom);
  
  // For edit mode, only set state when getData has the id (meaning data is loaded)
  if (props.callFrom === "edit" && getData && getData.id) {
    setState({
      formData: {
        deviceName: getData.deviceName ? [getData.deviceName] : [],
        exposure: getData.exposure || "",
        protectionMeasure: getData.protectionMeasure || "",
        detectionMeasure: getData.detectionMeasure || "",
        distribution: getData.distribution || "",
        confidentialityRequirement: getData.confidentialityRequirement || "",
        integrityRequirement: getData.integrityRequirement || "",
        availabilityRequirement: getData.availabilityRequirement || "",
      },
      "deviceNameError": false,
      "deviceNameErrorMessage": "",
      "exposureError": false,
      "exposureErrorMessage": "",
      "protectionMeasureError": false,
      "protectionMeasureErrorMessage": "",
      "distributionError": false,
      "distributionErrorMessage": "",
      "confidentialityRequirementError": false,
      "confidentialityRequirementErrorMessage": "",
      "integrityRequirementError": false,
      "integrityRequirementErrorMessage": "",
      "availabilityRequirementError": false,
      "availabilityRequirementErrorMessage": "",
      "detectionMeasureError": false,
      "detectionMeasureErrorMessage": "",
    });
  }
  // For add mode, clear the form
  else if (props.callFrom === "add") {
    setState({
      formData: { ...initialFormData },
      // ... all error states set to false
    });
  }
}, [getData, props.callFrom]);

  useEffect(() => {
    const isDataEmptyOrZero = isInitialFormDataEmptyOrZero(state.formData);
    setDisable(isDataEmptyOrZero);
  }, [state.formData, initialFormData, typeList]);

  const clearForm = () => {
    setState({ formData: { ...initialFormData } });
  };
  const [serverOpt, setServerOpt] = useState([]);
  useEffect(() => {
    if (props.open) {
      clearForm();
    }
  }, [props.open]);
  useEffect(() => {
    dispatch(getServerList(getCmdbId));
    setKeyforType(false);
  }, []);

  useEffect(() => {
    serverOptions();
  }, [serverList]);
  useEffect(() => {
    if (typeList !== "" && typeList !== "[]" && keyforType === true) {
      console.log(typeList);
      setState((state) => ({
        ...state,
        initialEdit: false,
        formData: { ...state.formData, ["type"]: typeList },
      }));
    } else {
      setState((state) => ({
        ...state,
        initialEdit: false,
        formData: { ...state.formData, ["type"]: "" },
      }));
    }
  }, [typeList]);
 //const checkOption = ["K8DOL11", "K9DOL12"]
  const serverOptions = () => {
    let options = [];
    serverList.map((maindata, mainIndex) => {
      options.push({ value: maindata, label: maindata });
      return maindata;
    });
    setServerOpt(options);
  };


  const validateForm = () => {
  let tmpFormFields = cloneDeep(state.formData);

  const { type, ...tmpFormField } = tmpFormFields;
  tmpFormFields = tmpFormField;

  let formValidation = true;

  Object.keys(tmpFormFields).forEach((key) => {
    // Special handling for deviceName array
    if (key === "deviceName") {
      if (
        !Array.isArray(tmpFormFields[key]) ||
        tmpFormFields[key].length === 0
      ) {
        setState((state) => ({
          ...state,
          [`${key}Error`]: true,
          [`${key}ErrorMessage`]: `Field should not be empty`,
        }));
        formValidation = false;
      }
    } else if (tmpFormFields[key] === "" || tmpFormFields.dateValue === 0) {
      setState((state) => ({
        ...state,
        [`${key}Error`]: true,
        [`${key}ErrorMessage`]: `Field should not be empty`,
      }));
      formValidation = false;
    }
  });

  return formValidation;
};

  // const saveAPICall=(payload)=>{
  //   dispatch(
  //     saveAsset(payload)
  //   ).then((resp) => {
  //       setStateAlert(stateAlert => ({
  //         ...stateAlert,
  //         alert: true,
  //         alertType: "success",
  //         alertMessage: resp.payload,
  //       }));
  //   });
  // }
  AssetConfigurationObj.serverOpt = serverOpt;
  const saveAssetFunction = () => {
   
    const validation = validateForm();
    
    if (validation && dubValidation) {
      const {
        deviceName,
        exposure,
        protectionMeasure,
        detectionMeasure,
        distribution,
        confidentialityRequirement,
        integrityRequirement,
        availabilityRequirement,
      } = state.formData;
      const Payload = {
        userName,
        payload: {
          availabilityRequirement: availabilityRequirement,
          cmdbId: getCmdbId,
          confidentialityRequirement: confidentialityRequirement,
          detectionMeasure: detectionMeasure,
          distribution: distribution,
          exposure: exposure,
          integrityRequirement: integrityRequirement,
          protectionMeasure: protectionMeasure,
          deviceName: deviceName,
        },
        listPayload: props.reloadPayload,
      };

      props.saveAPICall(Payload);
      props.handleClose();
    }
  };
  const addmodalCancelConfig = () => {
    setState((state) => ({
      ...state,
      addBodyConfig: true,
    }));
  };
  const addBodyCloseConfig = () => {
    setState({
      ...state,
      addBodyConfig: false,
    });
  };
  const addBodyCancelConfig = () => {
    return (
      <>
        <DiscardChanges title={props.callFrom === "edit" ? "edit" : "add"} discardClick={cancelAsset} cancelClick={addBodyCloseConfig} />
      </>
    );
  };

  const cancelAsset = () => {
    props.handleClose();
  };
  const onChange = (name, value) => {
    if (state[`${name}Error`]) {
      setState((state) => ({
        ...state,
        [`${name}Error`]: false,
        [`${name}ErrorMessage`]: "",
      }));
    }
    setState((state) => ({
      ...state,
      initialEdit: false,
      formData: { ...state.formData, [name]: value },
    }));
    if (name == "deviceName") {
      // For multi-select, value will be an array
      const deviceNames = Array.isArray(value) ? value : [value];

      // Check if any of the selected device names already exist
      const duplicateDevices = deviceNames.filter(deviceName =>
        tableList?.data?.some((item) => item.deviceName === deviceName)
      );

      if (duplicateDevices.length > 0) {
        setState((state) => ({
          ...state,
          initialEdit: false,
          "deviceNameError": true,
          "deviceNameErrorMessage": `Device Name(s) already exist: ${duplicateDevices.join(', ')}`,
        }));
        setdubValidation(false);
      } else {
        // For type list, use the first selected device or handle multiple devices as needed
        if (deviceNames.length > 0) {
          const payload2 = {
            cmdbId: getCmdbId,
            deviceName: deviceNames[0], // Using first device for type list
          };
          setKeyforType(true);
          dispatch(getTypeList(payload2));
        }
        setdubValidation(true);
      }
    }
  };
  return (
    <>
      <div className="form">
        <h4 className="actionDescription m-0">{props.callFrom === "edit" ? "Update Asset Configuration" : "Add Asset Configuration"}</h4>
        {getLoading ? (
          <Spinners />
        ) : (
          AssetConfigurationObj.inputs.map((maindata, mainIndex) => {
            return (
              <div className="row m-0" key={mainIndex}>
                <label className="mb-10 modalSubhead">{maindata.title}</label>
                {maindata.inputs.map((data, index) => {
                  let options = AssetConfigurationObj[data.options];
                  return data.label !== "Type" ? (
                    <CustomSelectDropDown
                    key={index}
                    containerClassName={data.name === "deviceName" ? "frmgroup validate default-input col-12" : "frmgroup validate default-input col-6"}
                    labelName={data.label}
                    isSearchable={false}
                    placeholder={data.placeholder}
                    options={options}
                    error={state[`${data.name}Error`]}
                    errorMessage={state[`${data.name}ErrorMessage`]}
                    value={
                      data.name === "deviceName" 
                        ? (props.callFrom === "edit" && state.formData[data.name]
                            ? state.formData[data.name].map(val => ({ value: val, label: val }))
                            : Array.isArray(state.formData[data.name])
                              ? state.formData[data.name].map(val =>
                                  options.find((tool) => tool.value === val)
                                ).filter(Boolean)
                              : []
                          )
                        : options.find((tool) => tool.value === state.formData[data.name])
                    }
                    name={data.label}
                    onChange={(choice) => {
                      // Handle multi-select for deviceName
                      if (data.name === "deviceName") {
                        const selectedValues = Array.isArray(choice)
                          ? choice.map(item => item.value)
                          : [choice.value];
                        onChange(data.name, selectedValues);
                      } else {
                        onChange(data.name, choice.value);
                      }
                    }}
                    isDisabled={
                      data.name === "deviceName" && props.callFrom === "edit"
                        ? true
                        : false
                    }
                    isMulti={data.name === "deviceName" ? true : false}
                    tooltipText={data.tooltipText ? data.tooltipText : ''}
                  />
                  ) : (
                    <>
                      <Input
                        type={""}
                        label={data.label}
                        inputClassName={"form-control"}
                        //error={state.urlError}
                        //errorMessage={state.urlErrorMessage}
                        value={state.formData[data.name]}
                        //onChange={(e) => onChange(e.target.name, e.target.value)}
                        name={data.name}
                        //placeholder="Enter Your Tool URL"
                        autoComplete={"off"}
                        isDisabled={true}
                        disabled
                      />
                    </>
                  );
                })}
              </div>
            );
          })
        )}

        <div className="btn-container p-0-5">
          <CommonBtn
            name="Cancel"
            btnStyle="cancelBtnStyle btn-primary py-2 cancelBudget"
            clickFunc={() => {
              addmodalCancelConfig();
            }}
          />
          <ButtonComponent text="Save" onClick={() => { saveAssetFunction(); }} />
          {/* <CommonBtn
            name="Save"
            // disabled={isdisable || serverCopy}
            // istooltip={isdisable || serverCopy}
            // tooltipText={
            //   isdisable
            //     ? "Please fill all the above fields"
            //     : "" || serverCopy
            //     ? "Device Name already Exist!"
            //     : ""
            // }
            // tooltipPlacement={"top"}
            btnStyle="btnStyle btn btn-primary assetSave"
            clickFunc={saveAssetFunction}
          /> */}
          <CustomModal
            modalOpen={state.addBodyConfig}
            modalBody={addBodyCancelConfig}
            modalHide={addmodalCancelConfig}
            closeBtn={true}
            closeBtnFuc={addBodyCloseConfig}
          />

        </div>
      </div>
    </>
  );
};
export default memo(AddAssetConfig);
